import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import reducers from "store/reducers";
import thunk from "redux-thunk";
import { isObject } from "@cayuse/shared-react.utils.type-checks";
import { IS_DEV } from "globals/constants";
import {
	subscribeFacetedSearch,
	subscribeFormColumnHeaders,
} from "./subscriptions";

import { loaderMiddleware } from "./middlewares";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const middlewares = [
	thunk,
	loaderMiddleware,
];

if (IS_DEV) {
	// middlewares.push(logger);
}

export const store = createStore(
	combineReducers({ ...reducers }),
	composeEnhancers(applyMiddleware(...middlewares)),
);

export const getStore = () => {
	return isObject(store)
		? Promise.resolve(store)
		: new Promise(resolve => {
			setInterval(() => {
				if (isObject(store)) {
					resolve(store);
				}
			}, 20);
		});
};

export const dispatch = (payload) => {
	const actionKey = payload.meta?.actionKey;

	if (actionKey) {
		payload.type = `${actionKey}_${payload.type}`;
	}

	return store?.dispatch(payload);
};

export default store;

subscribeFacetedSearch();
subscribeFormColumnHeaders();
